export { default as CrehanaLogos } from './CrehanaLogos';
